
/* STAHLOR PRODUCT PREMIUM CLEANUP V1 */
(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function closestProductCard(el) {
    return el.closest(".product, .product-item, .single-product, .grid__item, .item, .col, [class*='product']");
  }

  ready(function () {
    document.body.classList.add("stahlor-product-premium-v1");

    var headings = Array.prototype.slice.call(document.querySelectorAll("h1,h2,h3"));
    headings.forEach(function (h) {
      var txt = (h.textContent || "").trim().toLowerCase();
      if (txt === "recently viewed" || txt.indexOf("recently viewed") >= 0) {
        h.textContent = "You may also like";
        var section = h.closest("section, .section, .container, .row, div");
        if (section) section.classList.add("stahlor-related-section");
      }
      if (txt.indexOf("related") >= 0 || txt.indexOf("you may also like") >= 0) {
        var section2 = h.closest("section, .section, .container, .row, div");
        if (section2) section2.classList.add("stahlor-related-section");
      }
    });

    var productLinks = Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/"]'));
    productLinks.forEach(function (link) {
      var card = closestProductCard(link);
      if (!card) return;

      var sectionText = "";
      var section = card.closest("section, .section, .container, div");
      if (section) sectionText = (section.textContent || "").toLowerCase();

      var looksRelated = sectionText.indexOf("recently viewed") >= 0 ||
                         sectionText.indexOf("you may also like") >= 0 ||
                         sectionText.indexOf("related") >= 0;

      if (!looksRelated) return;

      card.classList.add("stahlor-related-card");

      var img = card.querySelector("img");
      if (!img || !img.getAttribute("src")) {
        card.classList.add("stahlor-no-product-image");
      }
    });

    var relatedImages = Array.prototype.slice.call(document.querySelectorAll(
      ".stahlor-related-section img, .recently-viewed img, .recently-viewed-products img, .related-products img, .product-recommendations img"
    ));

    relatedImages.forEach(function (img) {
      img.removeAttribute("width");
      img.removeAttribute("height");
      img.style.objectFit = "contain";
    });
  });
})();
